// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Contact-pageTitle-pdCOj {
  font-size: 22px;
  font-weight: 700;
  color: #1F2733;
  margin: 0 0 8px;
  font-family: 'Poppins', sans-serif;
}

.Contact-subText-nRNWv {
  font-size: 15px;
  color: #555;
  margin: 0 0 22px;
}

.Contact-channelList-L2fA8 {
  list-style: none;
  padding: 0;
  margin: 0;
}

.Contact-channelItem-kS9br {
  margin-bottom: 14px;
}

.Contact-channelLink-mUnFp {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  gap: 12px;
  padding: 18px 20px;
  border: 1px solid #ECECEC;
  border-radius: 14px;
  background: #fff;
  text-decoration: none;
  -webkit-transition: all .15s ease;
  transition: all .15s ease;
}

.Contact-channelLink-mUnFp:hover {
  border-color: #D32F2F;
  background: #FFF6F4;
  text-decoration: none;
}

.Contact-channelInfo-lRyKl {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 4px;
}

.Contact-channelLabel-m3XcP {
  font-size: 15px;
  font-weight: 600;
  color: #1F2733;
}

.Contact-channelValue-YreIz {
  font-size: 14px;
  color: #555;
}

.Contact-channelArrow-h2VIC {
  font-size: 26px;
  line-height: 1;
  color: #D32F2F;
}

.Contact-emptyText-uBVAP {
  color: #777;
  font-size: 15px;
  padding: 20px 0;
}
`, "",{"version":3,"sources":["webpack://./src/routes/contact/Contact.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,iCAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB","sourcesContent":[".pageTitle {\n  font-size: 22px;\n  font-weight: 700;\n  color: #1F2733;\n  margin: 0 0 8px;\n  font-family: 'Poppins', sans-serif;\n}\n\n.subText {\n  font-size: 15px;\n  color: #555;\n  margin: 0 0 22px;\n}\n\n.channelList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.channelItem {\n  margin-bottom: 14px;\n}\n\n.channelLink {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 18px 20px;\n  border: 1px solid #ECECEC;\n  border-radius: 14px;\n  background: #fff;\n  text-decoration: none;\n  transition: all .15s ease;\n}\n\n.channelLink:hover {\n  border-color: #D32F2F;\n  background: #FFF6F4;\n  text-decoration: none;\n}\n\n.channelInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.channelLabel {\n  font-size: 15px;\n  font-weight: 600;\n  color: #1F2733;\n}\n\n.channelValue {\n  font-size: 14px;\n  color: #555;\n}\n\n.channelArrow {\n  font-size: 26px;\n  line-height: 1;\n  color: #D32F2F;\n}\n\n.emptyText {\n  color: #777;\n  font-size: 15px;\n  padding: 20px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageTitle": `Contact-pageTitle-pdCOj`,
	"subText": `Contact-subText-nRNWv`,
	"channelList": `Contact-channelList-L2fA8`,
	"channelItem": `Contact-channelItem-kS9br`,
	"channelLink": `Contact-channelLink-mUnFp`,
	"channelInfo": `Contact-channelInfo-lRyKl`,
	"channelLabel": `Contact-channelLabel-m3XcP`,
	"channelValue": `Contact-channelValue-YreIz`,
	"channelArrow": `Contact-channelArrow-h2VIC`,
	"emptyText": `Contact-emptyText-uBVAP`
};
module.exports = ___CSS_LOADER_EXPORT___;
